export default __webpack_public_path__ + "static/media/IMG_4468.fcd18fed.jpg";